import { atom } from "recoil";
// import { defaultData, defaultProfileData } from './defaultData';
import type { FeedbackSource } from "@bto/shared";
import {
  BabyPeekReveal,
  UserAuthClientResponse,
  UserProfileAuthClientResponse,
} from "./types";
import { BillPreview } from "../components/UpfrontPayment/Services/UpfrontPaymentService";

const getDefaultData = () => {
  if (import.meta.env.VITE_ENV === "local") {
    //  return defaultData; // can be set to defaultData if testing of dummy data is needed
  }
  return undefined;
};

const getDefaultProfileData = () => {
  if (import.meta.env.VITE_ENV === "local") {
    // return defaultProfileData; // can be set to defaultData if testing of dummy data is needed
  }
  return undefined;
};

export const patientState = atom<UserAuthClientResponse | undefined>({
  key: "detailedResults",
  default: getDefaultData(),
});

export const patientProfileState = atom<
  UserProfileAuthClientResponse | undefined
>({
  key: "detailedProfileResults",
  default: getDefaultProfileData(),
});

export const resetPwEmail = atom<string | undefined>({
  key: "resetPwEmail",
  default: undefined,
});

export const selectedRequisitionIndex = atom<number>({
  key: "selectedRequisitionIndex",
  default: 0,
});

export const babyPeekStatus = atom<BabyPeekReveal>({
  key: "babyPeekPending",
  default: "hidden",
});

export const showABNForm = atom<{ loaded: boolean; show: boolean }>({
  key: "showABNForm",
  default: { loaded: false, show: false },
});

export const billPreviewsState = atom<BillPreview[]>({
  key: "billPreviews",
  default: [],
});

export const billPreviewsLoadingState = atom<boolean>({
  key: "billPreviewsLoading",
  default: true,
});

export const failedPaymentBillPkState = atom<string>({
  key: "failedPaymentBillPk",
  default: "",
});

export const feedbackModalOpenState = atom<boolean | null>({
  key: "feedbackModalOpen",
  default: null,
});

export const feedbackSourceState = atom<FeedbackSource | null>({
  key: "feedbackSource",
  default: null,
});

/**
 * The LD context key the LaunchDarkly client has finished identify()-ing,
 * written by LdContextSync when the switch completes. null until the first
 * identify settles. Identity-sensitive flag readers (e.g. the standalone
 * fetal-sex rollout) use it to ignore flag values that were evaluated for a
 * previous context, such as the shared "anonymous" key right after login.
 */
export const ldSyncedContextKeyState = atom<string | null>({
  key: "ldSyncedContextKey",
  default: null,
});

/**
 * True while the LaunchDarkly client is switching to a different context.
 * identify() sets the client's context inside the flag-fetch continuation, so
 * getContext() reports the new key a moment before the new flag values reach
 * React. During that window the client's context is not evidence that the
 * flags belong to it, and identity-sensitive readers must wait for
 * [[ldSyncedContextKeyState]] instead.
 */
export const ldIdentifyPendingState = atom<boolean>({
  key: "ldIdentifyPending",
  default: false,
});
